/**
 * @author EdenCha <eden@nurigo.net>
 */
import React from 'react'
import qs from 'query-string'
import withStyles from '@material-ui/core/styles/withStyles'
import TextField from '@material-ui/core/TextField'
import InputAdornment from '@material-ui/core/InputAdornment'
import Grid from '@material-ui/core/Grid'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import SearchIcon from '@material-ui/icons/Search'
import LayoutHeaderMenuContainer from 'containers/LayoutHeaderMenuContainer'
import config from 'config'

const styles = theme => ({})

const AppstoreSearchBar = props => {
  const { classes, ...others } = props
  const { proxy, categories } = others
  const { onChangeCategories, onKeyPressSearchField } = proxy
  const search = window.location.search
  const { appName, categories: searchCategories } = qs.parse(
    search.replace(/^\?/, ''),
    { arrayFormat: 'bracket' }
  )
  return (
    <Grid container justify="flex-end" alignItems="center" spacing={1}>
      <Grid item xs={3} sm="auto">
        <FormControl fullWidth>
          <Select
            multiple
            value={categories || searchCategories || ['']}
            onChange={onChangeCategories}
            inputProps={{ name: 'categories', id: 'categories' }}
          >
            <MenuItem value="">전체</MenuItem>
            {Object.keys(config.categories).map(category => {
              return (
                <MenuItem key={category} value={category}>
                  {config.categories[category]}
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={7} sm="auto">
        <TextField
          fullWidth
          placeholder="Search.."
          defaultValue={appName}
          InputProps={{
            onKeyPress: onKeyPressSearchField,
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            )
          }}
        />
      </Grid>
      <Grid item xs={2} sm="auto">
        <LayoutHeaderMenuContainer isAppstore />
      </Grid>
    </Grid>
  )
}
export default withStyles(styles, { withTheme: true })(AppstoreSearchBar)
